export var ZeroEtlPolicySortField;
(function (ZeroEtlPolicySortField) {
    ZeroEtlPolicySortField["ZERO_ETL_POLICY_SORT_FIELD_CREATED_AT"] = "createdAt";
    ZeroEtlPolicySortField["ZERO_ETL_POLICY_SORT_FIELD_NAME"] = "name";
})(ZeroEtlPolicySortField || (ZeroEtlPolicySortField = {}));
